import React from 'react'
import { Form } from 'react-bootstrap'
import { type CustomIntegrationAuthType } from '../../../models/CustomIntegration'
import { type AuthFormState } from '../form/customIntegrationForm'
import { IdentityFormFields } from './IdentityFormFields'
import { OAuth2FormFields } from './OAuth2FormFields'

interface AuthDetailsFormFieldsProps {
  authType: CustomIntegrationAuthType
  state: AuthFormState
  onChange: (state: AuthFormState) => void
  disabled?: boolean
  hasStoredSecret?: boolean
}

export const AuthDetailsFormFields: React.FC<AuthDetailsFormFieldsProps> = ({ authType, state, onChange, disabled = false, hasStoredSecret = false }) => {
  if (authType === 'oauth2') {
    return <OAuth2FormFields data={state.oauth2} onChange={(oauth2) => onChange({ ...state, oauth2 })} disabled={disabled} hasStoredSecret={hasStoredSecret} />
  }
  if (authType === 'oauth2Dcr') {
    return (
      <div className='d-flex flex-column gap-3'>
        <div className='d-flex flex-column zocks-gap-0.25'>
          <span className='paragraph-medium fw-bold zocks-text-gray-900'>Optional Preferences</span>
          <span className='paragraph-small zocks-text-gray-600'>Provide optional identity fields, if any.</span>
        </div>
        <IdentityFormFields identity={state.oauth2Dcr.identity} onChange={(identity) => onChange({ ...state, oauth2Dcr: { identity } })} disabled={disabled} />
      </div>
    )
  }
  if (authType === 'apiKey') {
    return (
      <Form.Group controlId='custom-integration-api-key-header'>
        <Form.Label className='paragraph-small mb-1'>Header name</Form.Label>
        <Form.Control
          type='text'
          placeholder='X-Api-Key'
          value={state.apiKey.headerName}
          disabled={disabled}
          onChange={(e) => onChange({ ...state, apiKey: { headerName: e.target.value } })}
        />
        <Form.Text className='paragraph-extra-small zocks-text-gray-600'>The request header Zocks sends each user&apos;s API key in.</Form.Text>
      </Form.Group>
    )
  }
  return null
}
